/* eslint-disable import/prefer-default-export */

const ACTION_LOGIN = 'LOGIN'
const ACTION_LOGOUT = 'LOGOUT'

export {
  ACTION_LOGIN,
  ACTION_LOGOUT,
}



// WEBPACK FOOTER //
// ./client/store/actions.js